import Rental from "../../../rental/rental";
import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const CarPark = {

    init() {
        this.el = $('[page].CarPark');
        if (!this.el.length) return;

        this.left = this.el.find('[block="left"]');
        this.leftScrollableWrap = this.left.find(".scrollable");
        this.right = this.el.find('[block="right"]');
        this.links = this.el.find("header a, nav a");
        this.items = this.right.find('section');
        this.menu = $(".CarParkCategories");
        this.skeletons = this.el.find('[element="skeleton"]');

        this.start();
        this.bind();
        this.resize();
    },

    start() {
        this.setActiveListFromUrl();

        setTimeout(() => {
            this.skeletons.each((index, element) => {
                $(element).fadeOut(300);
            });
        }, 500);
    },

    bind() {
        this.links.on("click", (evt) => {
            evt.preventDefault();
            const el = $(evt.currentTarget);

            let newUrl = el.attr("href"),
                categoryID = el.attr("category");

            history.pushState(null, null, newUrl);
            this.setActiveSection(categoryID);
        });

        this.el.find('.vehicle .button.next').click((evt) => {
            evt.stopPropagation();
            const id = $(evt.currentTarget).closest('.vehicle').attr('item');
            this.setVehicle(id);
            return false;
        })

        $(document).on("scroll", function () {
            if ($(window).scrollTop() < 200) {
                CarPark.leftScrollableWrap.scrollTop(0);
            }
        });
    },

    setVehicle(id) {
        if (rentalHash) Rental.load(null, {vehicle: id});
        window.location.href = '/' + window.T.rental.routes.reservation + '?vehicle=' + id;
    },

    setActiveSection(categoryID) {
        this.setActiveInMenu(categoryID);
        this.setActiveList(categoryID);
    },

    setActiveInMenu(categoryID) {
        this.menu.find(".active").removeClass("active");
        this.menu.find('[category="' + categoryID + '"]').addClass("active");
    },

    setActiveList(categoryID) {
        let activeHeight = 0;
        let shift = 0;
        const active = this.items.filter('.active');
        const current = this.items.filter('[category="' + categoryID + '"]');

        if (active.length) {
            activeHeight = active.find('main').outerHeight();
            shift = active.attr('order') < current.attr('order') ? activeHeight : 0;
            this.close(active);
        }

        if (this.categoryID === categoryID) {
            this.categoryID = null;
            return;
        }

        this.categoryID = categoryID;
        this.open(current);
        this.scroll(current, shift);

        setTimeout(() => {
            AOS.refresh();
        }, 510)
    },

    open(current) {
        gsap.set(current.find('main'), {height: "auto", paddingTop: 24, paddingBottom: 16});
        gsap.from(current.find('main'), {height: 0, paddingTop: 0, paddingBottom: 0});
        current.addClass('active');
    },

    close(active) {
        gsap.to(active.find('main'), {height: 0, paddingTop: 0, paddingBottom: 0});
        active.removeClass('active');
    },

    scroll(current, shift) {
        if(this.scrollPaused){
            this.scrollPaused = false;
            return;
        }
        const y = current.offset().top - shift;
        const offset = $('[component="Header"]').outerHeight() + 16;
        // console.log('scroll', y, shift, offset)
        gsap.to('html, body', {scrollTo: {y: y, offsetY: offset}})
    },

    setActiveListFromUrl() {
        const [urlRoot, url] = (new URL(window.location.href).pathname.split("/").filter(Boolean));
        let active = this.items.filter('[id="' + url + '"]');
        if (!active.length) {
            active = $(this.items[0]);
            this.scrollPaused = true;
        }

        setTimeout(() => {
            this.setActiveList(active.attr("category"));
            this.setActiveInMenu(active.attr("category"));
        }, 1);
    },

    resize() {
        if (!this.el.length) return;
        this.setAnimation();
    },

    setAnimation(cars) {
        const countInRow = this.el.find('main').css('--itemsInRow');

        this.el.find('main').each((i, section)=>{
            $(section).find('.vehicle .content').each((i, el) => {
                const time = (i % countInRow) * 200;
                $(el).attr('data-aos-delay', time)
            })
        })

    },

}

export default CarPark;